import React, { useEffect, useRef } from 'react';

export default function App() {
  const wsRef = useRef(null);

  useEffect(() => {
    const WS_URL =
      'wss://backend-pr-app-928105274191.me-central1.run.app/app/localkey?protocol=7&client=js&version=7.0.6&flash=false';

    const ws = new WebSocket(WS_URL);
    wsRef.current = ws;

    ws.onopen = () => {
      console.log('✅ WebSocket connected');
    };

    ws.onmessage = (event) => {
      console.log('📩 RAW MESSAGE:', event.data);

      let payload;
      try {
        payload = JSON.parse(event.data);
      } catch (e) {
        console.error('Invalid JSON:', e);
        return;
      }

      // 1️⃣ Connection handshake
      if (payload.event === 'pusher:connection_established') {
        console.log('🔐 Connection established');

        const socketId = JSON.parse(payload.data).socket_id;
        console.log('🆔 Socket ID:', socketId);

        // 2️⃣ Subscribe to PUBLIC channel
        ws.send(
          JSON.stringify({
            event: 'pusher:subscribe',
            data: {
              channel: 'orders-board',
            },
          })
        );

        console.log('📡 Subscribed to orders-board');
      }

      // 3️⃣ Subscription succeeded
      if (payload.event === 'pusher_internal:subscription_succeeded') {
        console.log('✅ Subscription successful');
      }

      // 4️⃣ Your Laravel event
      if (payload.event === 'order.updated') {
        console.log('🚀 Order Updated EVENT:', payload.data);
      }

      // Debug all events
      if (
        ![
          'pusher:connection_established',
          'pusher_internal:subscription_succeeded',
        ].includes(payload.event)
      ) {
        console.log('📨 Event:', payload.event, payload.data);
      }
    };

    ws.onerror = (error) => {
      console.error('❌ WebSocket error:', error);
    };

    ws.onclose = (event) => {
      console.warn('⚠ WebSocket closed:', event);
    };

    return () => {
      console.log('🔌 Closing WebSocket');
      ws.close();
    };
  }, []);

  return (
    <div style={{ padding: 40 }}>
      <h1>Laravel WebSockets (No Echo, No Pusher)</h1>
      <p>Open DevTools → Console to see events</p>
    </div>
  );
}
